import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Instagram } from "lucide-react";
import { INSTAGRAM_URL, CTA_TEXT } from "@/constants/seo";

export const StickyCTA = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.9);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-[100] border-t border-white/10 bg-[#0a0a0b]/85 p-4 backdrop-blur-xl md:hidden"
        >
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="sticky-cta"
            className="flex w-full items-center justify-center gap-3 bg-[#d4af37] py-4 font-semibold uppercase tracking-[0.16em] text-sm text-black"
          >
            <Instagram className="h-4 w-4" />
            {CTA_TEXT}
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
